import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">KKP Trade LTD</h1>
          <p className="hero-subtitle">Your Trusted Cash & Carry Wholesale Partner in London</p>
          <div className="hero-info">
            <p><strong>Owner:</strong> Kaushaliya Kanaiyalal Prajapat</p>
            <p><strong>Email:</strong> <a href="mailto:kkptradeltd@gmail.com">kkptradeltd@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+447432496113">07432 496113</a></p>
            <p><strong>Address:</strong> 317-319 Lower High St, Watford, WD17 2JD</p>
          </div>
          <a href="#contact" className="hero-cta">Get Wholesale Quotes</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;